module.exports = __webpack_public_path__ + "static/media/Mema_Primary_Brandmark_1736357877636.c0d87eee.png";